module.exports = __webpack_public_path__ + "static/media/noFilters.919baecf.svg";